import React from 'react';
import { Modal } from 'rsuite';
import { AllegroReturnPolicy } from '../../../../api/allegro/returnpolicy/returnPolicyTypes';
import EshopSetupAllegroReturnPolicyEdit from './Edit/EshopSetupAllegroReturnPolicyEdit';

const EDIT_TITLE = 'Edit return terms';
const CREATE_TITLE = 'Create return terms';

interface Props {
  isOpen: boolean;
  marketplaceCode: string;
  returnPolicy?: AllegroReturnPolicy;
  onClose: () => void;
  onSaved: () => void;
}

export default function EshopSetupAllegroReturnPolicyEditModal({
  isOpen,
  marketplaceCode,
  returnPolicy,
  onClose,
  onSaved,
}: Props): JSX.Element {
  const title = returnPolicy ? EDIT_TITLE : CREATE_TITLE;

  return (
    <Modal
      open={isOpen}
      onClose={() => onClose()}
      backdrop="static"
      overflow
    >
      <Modal.Header>
        <Modal.Title>
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <EshopSetupAllegroReturnPolicyEdit
          marketplaceCode={marketplaceCode}
          returnPolicy={returnPolicy}
          onCancel={() => onClose()}
          onSaved={() => onSaved()}
        />
      </Modal.Body>
    </Modal>
  );
}

EshopSetupAllegroReturnPolicyEditModal.defaultProps = {
  returnPolicy: undefined,
};
